import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { resetAllCollections, resetUploadedFeatures } from "../../slices/orderSlice";
import { resetSelectedFeature } from "../../slices/searchSlice";
import "./HeaderOptions.css";
import { Tooltip } from "react-tooltip";
import * as mapActions from "../../slices/mapSlice";
import * as searchActions from "../../slices/searchSlice";
import Pen from "../../assets/images/svgs/Pen.svg?react"
import SearchIcon from "../../assets/images/svgs/SearchIcon.svg?react"
import ExplorerSvg from '../../assets/images/svgs/Explorer.svg?react';

const HeaderOptions = ({ props }) => {
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);

  const collectionsView = useSelector((state) => state.map.collectionsView);
  const webtileView = useSelector((state) => state.map.webtileView);
  const geometry = useSelector((state) => state.map.geometry);
  const displayView = useSelector((state) => state.map.displayView);
  const multiSearchView = useSelector((state) => state.map.multiSearchView);
  const searchView = useSelector((state) => state.map.searchView);
  const analysisMode = useSelector((state) => state.map.analysisMode);

  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const setPage = (item) => {
    if (item === "Order Creation") {
      dispatch(mapActions.setDisplayView("createOrderView"));
      // navigate('/createOrder');
      dispatch(mapActions.resetSearchedAoi());
      dispatch(resetSelectedFeature());
      dispatch(resetAllCollections());
      dispatch(mapActions.resetSearchView());
      dispatch(mapActions.setMode('draw_polygon'));
      dispatch(mapActions.drawAOI('draw_polygon'));
    }
  };

  const setTopBarItem = (item) => {
    dispatch(mapActions.showSidebarRight());
    if (item === "Collection") {
      props.setIsSelectedTopBarItem({
        Collection: true,
        Archive: false,
        Configuration: false,
        Comparison: false,
        Visualization: false,
      });
    } else if (item === "Archive") {
      props.setIsSelectedTopBarItem({
        Collection: false,
        Archive: true,
        Configuration: false,
        Comparison: false,
        Visualization: false,
      });
    } else if (item === "Configuration") {
      props.setIsSelectedTopBarItem({
        Collection: false,
        Archive: false,
        Configuration: true,
        Comparison: false,
        Visualization: false,
      });
    } else if (item === "Comparison") {
      props.setIsSelectedTopBarItem({
        Collection: false,
        Archive: false,
        Configuration: false,
        Comparison: true,
        Visualization: false,
      });
    } else if (item === "Visualization") {
      props.setIsSelectedTopBarItem({
        Collection: false,
        Archive: false,
        Configuration: false,
        Comparison: false,
        Visualization: true,
      });
    }
  };

  const drawFeatures = (state) => {
    dispatch(mapActions.drawAOI(state.map.mode));
  };
  const drawMultiFeatures = (state) => {    
    dispatch(mapActions.drawAOI(state.map.mode));
  };

  const openDrawMode = () => {
    if(multiSearchView){
      dispatch(resetAllCollections());
      dispatch(searchActions.setInnerActiveKey(null));
      dispatch(searchActions.resetMultiStacData());
      dispatch(mapActions.resetDisplayView());
      dispatch(mapActions.resetMultiSearchView());
      dispatch(mapActions.resetHighlightAOI());
      dispatch(mapActions.resetMultiAOICoordinates());
    }
    if (Object.keys(geometry).length > 0) {
      dispatch(mapActions.drawEditModeAOI(geometry));
    } else {
      dispatch(mapActions.selectMode("draw_polygon", drawFeatures));
    }
    dispatch(mapActions.resetSearchedAoi());
    dispatch(mapActions.setDisplayView("drawView"));
    dispatch(resetAllCollections());
    dispatch(resetSelectedFeature());
  };

  const closeDrawMode = () => {
    if (analysisMode) {
      dispatch(mapActions.resetAnalysisMode());
    }
    dispatch(mapActions.resetCoordinatesGeometry());
    dispatch(resetUploadedFeatures());
    dispatch(mapActions.cleanUpDraw());
    dispatch(mapActions.resetSearchView());
    dispatch(mapActions.resetDisplayView());
    dispatch(mapActions.resetMode());
  };

  const openAnalysisMode = () => {
    if(searchView){
      dispatch(resetAllCollections());
      dispatch(searchActions.setInnerActiveKey(null));
      dispatch(searchActions.resetSelectedFeature());
      dispatch(mapActions.resetCoordinatesGeometry());
      dispatch(mapActions.resetDisplayView());
      dispatch(mapActions.resetSearchView());
      dispatch(mapActions.resetSearchedAoi());
    }    
    dispatch(mapActions.setAnalysisMode());
    dispatch(mapActions.selectMode("draw_polygon", drawMultiFeatures));
    dispatch(mapActions.resetSearchedAoi());
    dispatch(mapActions.setDisplayView("drawView"));
    dispatch(resetAllCollections());
    dispatch(resetSelectedFeature());
  };

  return (
    <>
      <div className="headerOptions">
        {!webtileView && (
          <>
            <div className="headerOptionsItem whiteBorder">
              <button
                data-tooltip-id="DrawBtn"
                data-tooltip-content="Draw"
                data-tooltip-place="top"
                className={displayView === 'drawView' ? "headerOptionsSubItem drawActive" : "headerOptionsSubItem"}
                onClick={() => (displayView === 'drawView' ? closeDrawMode() : openDrawMode())}
              >
                <ExplorerSvg /> Explorer
              </button>
              <Tooltip id="DrawBtn" />
            </div>
          </>
        )}
        {!collectionsView && (
          <>
            <div className="headerOptionsItem whiteBorder">
              <button
                data-tooltip-id="OrderBtn"
                data-tooltip-content="Order"
                data-tooltip-place="bottom"
                className="headerOptionsSubItem"
                onClick={() => setPage("Order Creation")}
              >
                <div style={{ fontSize: "26px" }}>+</div> Order
              </button>

              <Tooltip id="OrderBtn" />
            </div>
            {/* <div className="headerOptionsItem whiteBorder">
              <button
                data-tooltip-id="AnalysisBtn"
                data-tooltip-content="Analysis"
                data-tooltip-place="bottom"
                className="headerOptionsSubItem"
                onClick={openAnalysisMode}
                >
                Analyze
              </button>
              <Tooltip id="AnalysisBtn" />
            </div> */}
          </>
        )}
        {collectionsView && (
          <>
            <button
              data-tooltip-id="SearchBtn"
              data-tooltip-content="Search"
              data-tooltip-place="bottom"
              className="headerOptionsItem"
              onClick={() => setIsSearchBarOpen(!isSearchBarOpen)}
            >
              {isSearchBarOpen && (
                <div className="searchBtnText">Type here to search</div>
              )}
              <SearchIcon />
            </button>
            <Tooltip id="SearchBtn" />

            <button
              data-tooltip-id="ConfigurationBtn"
              data-tooltip-content="Admin Configuration"
              data-tooltip-place="bottom"
              className={
                props.isSelectedTopBarItem.Configuration
                  ? "headerOptionsItem active"
                  : "headerOptionsItem"
              }
              onClick={() => {
                setTopBarItem("Configuration");
              }}
            >
              <img
                src={
                  require("./../../assets/images/svgs/ConfigurationIcon.svg")
                    .default
                }
                alt="config-icon"
              />
            </button>
            <Tooltip id="ConfigurationBtn" />

            <div className="headerOptionsItem whiteBorder">
              <button
                className="headerOptionsSubItem rightBorder"
                onClick={() => setPage("Order Creation")}
              >
                <div style={{ fontSize: "26px" }}>+</div> Order
              </button>

              <button
                data-tooltip-id="CollectionBtn"
                data-tooltip-content="Collection"
                data-tooltip-place="bottom"
                className={
                  props.isSelectedTopBarItem.Collection
                    ? "headerOptionsSubItem active"
                    : "headerOptionsSubItem"
                }
                onClick={() => {
                  setTopBarItem("Collection");
                }}
              >
                <img
                  src={
                    require("./../../assets/images/svgs/GalleryIcon.svg")
                      .default
                  }
                  alt="gallery-icon"
                />
              </button>
            </div>
            <Tooltip id="CollectionBtn" />
          </>
        )}
        {collectionsView && (
          <>
            <button
              data-tooltip-id="ArchiveBtn"
              data-tooltip-content="Archive"
              data-tooltip-place="bottom"
              className={
                props.isSelectedTopBarItem.Archive
                  ? "headerOptionsItem active"
                  : "headerOptionsItem"
              }
              onClick={() => {
                setTopBarItem("Archive");
              }}
            >
              <img
                src={
                  require("./../../assets/images/svgs/ArchiveIcon.svg").default
                }
                alt="archive-icon"
              />
            </button>
            <Tooltip id="ArchiveBtn" />

            <button
              data-tooltip-id="ComparisonBtn"
              data-tooltip-content="Comparison"
              data-tooltip-place="bottom"
              className={
                props.isSelectedTopBarItem.Comparison
                  ? "headerOptionsItem active"
                  : "headerOptionsItem"
              }
              onClick={() => {
                setTopBarItem("Comparison");
              }}
            >
              <img
                src={
                  require("./../../assets/images/svgs/ABComparisonIcon.svg")
                    .default
                }
                alt="compare-icon"
              />
            </button>
            <Tooltip id="ComparisonBtn" />

            <button
              data-tooltip-id="udpBottomBarMarkup"
              data-tooltip-content="Markup"
              data-tooltip-place="bottom"
              className="headerOptionsItem"
            >
              <img
                src={
                  require("./../../assets/images/svgs/NotesIcon.svg").default
                }
                alt="notes-icon"
              />
            </button>
            <Tooltip id="udpBottomBarMarkup" />

            <button
              data-tooltip-id="VisualizationBtn"
              data-tooltip-content="Visualization"
              data-tooltip-place="bottom"
              className={
                props.isSelectedTopBarItem.Visualization
                  ? "headerOptionsItem active"
                  : "headerOptionsItem"
              }
              onClick={() => {
                setTopBarItem("Visualization");
              }}
            >
              <img
                src={
                  require("./../../assets/images/svgs/ImageIcon.svg").default
                }
                alt="img-icon"
              />
            </button>
            <Tooltip id="VisualizationBtn" />
          </>
        )}
      </div >
    </>
  );
};

export default HeaderOptions;
